import { render, staticRenderFns } from "./ShareRequestDetails.vue?vue&type=template&id=26ac8d70&scoped=true"
import script from "./ShareRequestDetails.vue?vue&type=script&lang=js"
export * from "./ShareRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac8d70",
  null
  
)

export default component.exports